import { useColorScheme } from '@mui/material'
import { useEffect } from 'react'

const useColorSchemeListener = () => {
  const { setMode } = useColorScheme()
  const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')

  const changeTheme = () => {
    setMode(mediaQuery.matches ? 'dark' : 'light')
  }

  useEffect(() => {
    changeTheme()
    mediaQuery.addEventListener('change', changeTheme)
    return () => mediaQuery.removeEventListener('change', changeTheme)
  }, [])
}

export default useColorSchemeListener
